/**
 * ParamContext: 将 routerParam 插入到 context 中, 令子组件调用
 */
import React from 'react';
export default React.createContext(null);